<div *ngIf="existingRegistration" class="alert alert-success text-center">
  <h4>You Are Registered!</h4>
  <div class="mb-3">Go to <a href="/account/events/conferences">My Upcoming Events</a> to view the events.</div>
  <a role="button" class="btn btn-primary" [routerLink]="['modify']" type="button">Modify Registration</a>
  <p>Click the button above to buy CEUs, Add-Ons or Additional Workshops</p>
  <div class="mt-3"><a *ngIf="conference.id != 285 && conference.id !=303" [routerLink]="['../', 'registration', 'group']">Group Registration, PO or for someone else? Click Here</a></div>
</div>

<ng-container *ngIf="packages && packages.length > 0">
  <div *ngIf="!existingRegistration || registerMore" class="row">
    <div class="col-md-6">
      <h4>Registration Options</h4>
      <div><a role="button" class="btn btn-primary mb-3" *ngIf="conference.id != 285 && conference.id !=303" [routerLink]="['../', 'registration', 'group']">Group Registration, PO or for someone else</a></div>
    </div>
  </div>

  <div *ngIf="!existingRegistration || registerMore" id="paymentDetails" class="accordion mb-9">
    <!-- Card -->
    <ul *ngIf="packageCategories.length > 1" class="nav nav-tabs">
      <li *ngFor="let category of packageCategories" class="nav-item">
        <a class="nav-link active" [ngClass]="{ active: activeCategory == category }" href="javascript:void(0);" (click)="changeCategory(category)">{{ category }}</a>
      </li>
    </ul>
    <ng-container *ngFor="let package of packages; let idx = index">
      <div *ngIf="packageCategories.length == 1 || activeCategory == package.category" class="card">
        <div class="card-header card-collapse" id="cardHeadingOne{{ idx }}">
          <h5 class="mb-0">
            <button class="btn btn-link btn-block card-btn p-3 collapsed" role="button" data-toggle="collapse" [attr.data-target]="'#cardOne' + idx" aria-expanded="false" [attr.aria-controls]="'#cardOne' + idx">
              <span class="row align-items-center">
                <span class="col-md-6 mb-2 mb-md-0">
                  <span class="media align-items-center">
                    <i class="fas fa-box mr-2"></i>
                    <span class="media-body">
                      <span class="font-size-1">{{ package.name }}</span>
                    </span>
                  </span>
                </span>
                <span  class="col-md-6 text-md-right mb-2">
                  <ng-container *ngIf="atLeastOnePackageHasCEUs">
                  <span *ngIf="package.ceuOverride && !package.noCEUs" class="btn btn-xs btn-soft-success btn-pill">{{ package.ceuOverride }} CEUs Available</span>
                  <span *ngIf="!package.noCEUs && !package.ceuOverride" class="text-muted"><i>
<!--                    <span *ngIf="(package.totalCEUs | ceuDisplay) == '0'">No CEUs</span>-->
                    <span *ngIf="(package.totalCEUs | ceuDisplay) != '0'">{{ package.totalCEUs | ceuDisplay }}  CEUs Available </span>
                    </i></span
                  >
                  <span *ngIf="package.noCEUs" class="btn btn-xs btn-soft-danger btn-pill">No CEUs</span>
    </ng-container>
                </span>
                <span class="col-md-6 col-md-3">
                  <span class="d-block font-size-1"
                    >{{ package.price | currency: package.currencyCode:'symbol' }} <span *ngIf="package.memberPricing && !conference.onlyAllowMembersToRegister">Member / {{ package.nonMemberPrice | currency: package.currencyCode:'symbol' }} Non-Member</span></span
                  >
                </span>
                <span class="col-md-6 text-right">
                  <a *ngIf="package.price == 0" role="button" [routerLink]="['../', 'registration', package.id]" class="btn btn-xs btn-primary mt-3">Register</a>
                  <a *ngIf="package.price > 0" role="button" [routerLink]="['../', 'registration', package.id]" class="btn btn-xs btn-primary mt-3">Buy</a>
                </span>
              </span>
            </button>
          </h5>
        </div>
      </div>
    </ng-container>

    <!-- End Card -->

    <!-- Card -->

    <!-- End Card -->
  </div>
</ng-container>
